import appConfig from '@src/app.config.ES6';

export const gtmMixin = {
  data() {
    return {
      gtmTrackPageView: (data) => {
        this.$gtm.trackEvent({
          event: 'pageView',
          category: 'Pageview',
          action: data.action || null,
          label: data.label || null,
          value: appConfig.THEME || null,
        });
      },
      gtmTrackAction: (data) => {
        this.$gtm.trackEvent({
          event: 'userAction',
          category: 'User Action',
          action: data.action || null,
          label: data.label || null,
          value: appConfig.THEME || null,
        });
      },
    };
  },
  methods: {
    gtmTrackEvent(type, data) {
      if (appConfig.NODE_ENV === 'production') {
        switch (type) {
          case 'pageView':
            this.gtmTrackPageView(data);
            break;
          case 'action':
            this.gtmTrackAction(data);
            break;
        }
      }
    },
  },
};
